import {
  required,
  TextInput,
  SimpleForm,
  BooleanInput,
} from 'react-admin';
import { ColorInput } from '@components/inputs/ColorInput';
import { ScheduleEditor } from '@components/schedule/ScheduleEditor';
import QueueIcon from '@mui/icons-material/Queue';

const validateRequired = [required()];

export const TicketQueueForm = (props: Record<string, unknown>) => (
  <SimpleForm warnWhenUnsavedChanges {...props}>
    <TextInput
      source="name"
      label="resources.ticket-queue.fields.name"
      validate={validateRequired}
      fullWidth
    />
    <ColorInput
      source="color"
      label="resources.ticket-queue.fields.color"
      fullWidth
    />
    <BooleanInput
      source="isDefault"
      label="resources.ticket-queue.fields.isDefault"
    />
    <TextInput
      source="greetingMessage"
      label="resources.ticket-queue.fields.greetingMessage"
      multiline
      rows={3}
      fullWidth
    />
    <TextInput
      source="outOfHoursMessage"
      label="resources.ticket-queue.fields.outOfHoursMessage"
      multiline
      rows={3}
      fullWidth
    />
    <ScheduleEditor source="schedules" />
  </SimpleForm>
);

export { TicketQueueList } from './List';
export { TicketQueueCreate } from './Create';
export { TicketQueueEdit } from './Edit';
export const TicketQueueIcon = QueueIcon;
